export enum FileTypeEnum {
    ID_DOCUMENT = 'IdDocument',
    LICENCE = 'Licence',
    PROOF_OF_ADDRESS = 'ProofOfAddress',
    PAYSLIP = 'Payslip',
    BANK_STATEMENT = 'BankStatement',
};